import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersGridComponent } from './users-grid.component';
import {
  DomainsSelectorDropdownModule,
  GridDefaultModule,
  GridTitleModule,
  ProfilePhotoUploadModule,
  RoleSelectorDropdownModule
} from 'shared';
import {TabModule} from '../../tab/tab.module';
import {DxDataGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [UsersGridComponent],
  imports: [
    CommonModule,
    DomainsSelectorDropdownModule,
    TabModule,
    DxDataGridModule,
    GridDefaultModule,
    GridTitleModule,
    RoleSelectorDropdownModule,
    ProfilePhotoUploadModule
  ],
  exports: [UsersGridComponent]
})
export class UsersGridModule { }
